export default {
  refreshSelectedNorm: 'coolingEfficiency.refreshSelectedNorm',
};
